var en = {
	"neptune.Button.loadingAriaLabel": "loading",
	"neptune.Chips.ariaLabel": "Clear {choice}",
	"neptune.ClearButton.ariaLabel": "Clear",
	"neptune.CloseButton.ariaLabel": "Close",
	"neptune.DateInput.day.label": "Day",
	"neptune.DateInput.day.placeholder": "DD",
	"neptune.DateInput.month.label": "Month",
	"neptune.DateInput.year.label": "Year",
	"neptune.DateInput.year.placeholder": "YYYY",
	"neptune.DateLookup.day": "day",
	"neptune.DateLookup.goTo20YearView": "Go to 20 year view",
	"neptune.DateLookup.month": "month",
	"neptune.DateLookup.next": "next",
	"neptune.DateLookup.previous": "previous",
	"neptune.DateLookup.selected": "selected",
	"neptune.DateLookup.twentyYears": "20 years",
	"neptune.DateLookup.year": "year",
	"neptune.FlowNavigation.back": "back to previous step",
	"neptune.Info.ariaLabel": "More information",
	"neptune.Label.optional": "(Optional)",
	"neptune.Link.opensInNewTab": "(opens in new tab)",
	"neptune.MoneyInput.Select.placeholder": "Select an option...",
	"neptune.MoneyInput.Select.selectCurrencyLabel": "Select currency",
	"neptune.PhoneNumberInput.SelectInput.placeholder": "Select an option...",
	"neptune.Select.searchPlaceholder": "Search...",
	"neptune.SelectInput.noResultsFound": "No results found",
	"neptune.SelectOption.action.label": "Choose",
	"neptune.SelectOption.selected.action.label": "Change chosen option",
	"neptune.StatusIcon.iconLabel.error": "Error:",
	"neptune.StatusIcon.iconLabel.information": "Information:",
	"neptune.StatusIcon.iconLabel.pending": "Pending:",
	"neptune.StatusIcon.iconLabel.success": "Success:",
	"neptune.StatusIcon.iconLabel.warning": "Warning:",
	"neptune.Summary.statusDone": "Item done",
	"neptune.Summary.statusNotDone": "Item to do",
	"neptune.Summary.statusPending": "Item pending",
	"neptune.Table.actionHeader": "Action",
	"neptune.Table.emptyData": "No results found",
	"neptune.Table.loaded": "Table data has loaded",
	"neptune.Table.loading": "Table data is loading",
	"neptune.Table.refreshPage": "Refresh page",
	"neptune.Upload.csButtonText": "Upload another file?",
	"neptune.Upload.csFailureText": "Upload failed. Please, try again",
	"neptune.Upload.csSuccessText": "Upload complete!",
	"neptune.Upload.csTooLargeMessage": "Please provide a file smaller than {maxSize}MB",
	"neptune.Upload.csWrongTypeMessage": "File type not supported. Please try again with a different file",
	"neptune.Upload.psButtonText": "Cancel",
	"neptune.Upload.psProcessingText": "Uploading...",
	"neptune.Upload.retry": "Retry",
	"neptune.Upload.usButtonText": "Or select a file",
	"neptune.Upload.usDropMessage": "Drop file to start upload",
	"neptune.Upload.usPlaceholder": "Drag and drop a file less than {maxSize}MB",
	"neptune.UploadButton.allFileTypes": "All file types",
	"neptune.UploadButton.dropFiles": "Drop file to start upload",
	"neptune.UploadButton.instructions": "{fileTypes}, less than {size}MB",
	"neptune.UploadButton.maximumFiles": "Maximum {maxFiles} files.",
	"neptune.UploadButton.uploadFile": "Upload file",
	"neptune.UploadButton.uploadFiles": "Upload files",
	"neptune.UploadInput.deleteModalBody": "Removing this file will delete it from our system.",
	"neptune.UploadInput.deleteModalCancelButtonText": "Cancel",
	"neptune.UploadInput.deleteModalConfirmButtonText": "Remove",
	"neptune.UploadInput.deleteModalTitle": "Sure you want to remove this file?",
	"neptune.UploadInput.fileIsTooLarge": "File is too large",
	"neptune.UploadInput.fileTypeNotSupported": "File type not supported",
	"neptune.UploadInput.maximumFilesAlreadyUploaded": "Sorry, this upload failed because we can only accept {maxFilesAllowed} files at once.",
	"neptune.UploadItem.deleting": "Deleting...",
	"neptune.UploadItem.removeFile": "Remove file {filename}",
	"neptune.UploadItem.uploaded": "Uploaded",
	"neptune.UploadItem.uploadedFile": "Uploaded file",
	"neptune.UploadItem.uploading": "Uploading...",
	"neptune.UploadItem.uploadingFailed": "Uploading failed"
};

export { en as default };
//# sourceMappingURL=en.json.mjs.map
